export default __webpack_public_path__ + "dff92b7ae220faa9b25aea2ada131501.png";